<template>
  <div>
    <div class="form__group" style="overflow: hidden">
      <label>{{ label }}</label>
      <textarea
          class="form__input"
          v-model="model"
          :placeholder="placeholder"
      ></textarea>
    </div>


  </div>
</template>

<script>

export default {
  name: 'ImageSelector',

  inheritAttrs: false,
  components: {},
  props: {
    label: String,
    placeholder: String,
    modelValue: String,
  },
  data() {
    return {
      model: '',

    }
  },
  watch: {
    'model': function () {
      console.log("model changed", this.model)
      this.$emit('update:modelValue', this.model);
    },
    'modelValue': function () {
      this.model = this.modelValue
      this.$emit('update:modelValue', this.model);
    }
  },
  computed: {},
  mounted() {

  },
  methods: {},


}
</script>
